export const CUSTOMER_MANAGEMENT_CUSTOMER_CONTROLLER_ROOT_PATH = "/customer";

export const CUSTOMER_MANAGEMENT_CUSTOMER_HEALTHCHECK_SUFFIX = "/healthcheck";
export const CUSTOMER_MANAGEMENT_CUSTOMER_HEALTHCHECK_PATH = `${
  CUSTOMER_MANAGEMENT_CUSTOMER_CONTROLLER_ROOT_PATH
}${
  CUSTOMER_MANAGEMENT_CUSTOMER_HEALTHCHECK_SUFFIX
}`;
